import { render, staticRenderFns } from "./RegistrosAnterioresManual.vue?vue&type=template&id=5afe4ac0&scoped=true&"
import script from "./RegistrosAnterioresManual.vue?vue&type=script&lang=js&"
export * from "./RegistrosAnterioresManual.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosAnterioresManual.vue?vue&type=style&index=0&id=5afe4ac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afe4ac0",
  null
  
)

export default component.exports